/**
 * Функция принимает URL и возвращает первую часть его относительного пути (pathname).
 */
function getFirstPartOfPath(url: URL) {
    // Разделяем путь на сегменты, удаляя пустые сегменты
    const [firstPart] = url.pathname
        .split('/')
        .filter(segment => segment.length > 0);

    return firstPart ?? '';
}

export default getFirstPartOfPath;
